let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bStmt")).then(() => parcelRequire('7JChl'));